export default __webpack_public_path__ + "49a5cb4c18cd283623b41bf14491ab27.webp";